import { IMDMUnitField, IMDMUnitInstance } from '@/pages/MDM/mdm.types.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import SeparateLine from '@/shared/Forms/SeparateLine'
import Button from '@/shared/Buttons/Button'
import useUnit from '@/pages/MDM/hooks/useUnit.ts'
import PrimitiveValueDropdown from '@/pages/MDM/components/Primitives/PrimitiveValueDropdown'
import TextArea from '@/shared/Inputs/TextArea'

interface IProps {
  onClose: () => void
  instance: IMDMUnitInstance
}

const EditUnitInstanceSidePageContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const unit = useUnit(props.instance.unitId)

  const [dto, setDto, handleChange] = useStateWithChange(props.instance)

  const { handleElementUpdate: handleValueUpdate } = useNestedArrayChangeCallbacks({
    sourceObjectSetter: setDto,
    nestedArrayKey: 'values',
  })

  const handleSave = () => {
    wait(mdmApi.updateUnitInstance(dto, props.instance.id), (resp) => {
      if (resp.status === 'success') {
        mdmEvents.unitInstanceUpdated(resp.body)
        props.onClose()
      }
    })
  }

  const renderFieldInput = (field: IMDMUnitField, index: number) => {
    if (!dto.values[index]) return null

    switch (field.type) {
      case 'ENUM':
        return (
          <PrimitiveValueDropdown
            primitiveId={field.typeEnumId}
            value={dto.values[index].enumValueId}
            name="enumValueId"
            onChange={(val, name) => handleValueUpdate(index, val, name)}
          />
        )
      default:
        return (
          <TextInput
            value={dto.values[index].value}
            name="value"
            placeHolder="Введите значение"
            onChange={(val, name) => handleValueUpdate(index, val, name)}
          />
        )
    }
  }

  return (
    <div className="flex-lines gap16 height100">
      <h4 className="text-heading-4">Создание экземпляра</h4>
      <SeparateLine />
      <FormField label="Родительский агрегат">
        <TextInput value={unit.name} name="unit_name" onChange={() => {}} disabled={true} />
      </FormField>
      <FormField label="Наименование" required={true}>
        <TextInput value={dto.name} name="name" onChange={handleChange} placeHolder="Введите наименование" />
      </FormField>
      <FormField label="Комменатрий" required={false}>
        <TextArea value={dto.comment} name="comment" onChange={handleChange} />
      </FormField>
      <SeparateLine />
      <h5 className="text-heading-5">Значения</h5>
      {unit.fields.map((f, index) => (
        <FormField label={f.name} key={f.id} required={true}>
          {renderFieldInput(f, index)}
        </FormField>
      ))}
      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8" style={{ paddingBottom: '24px' }}>
        <Button
          size="default"
          type="primary"
          disabled={!unit.name}
          loading={loading}
          onClick={handleSave}
          text="Сохранить"
        />
        <Button size="default" type="default" onClick={props.onClose} disabled={loading} text="Отмена" />
      </div>
    </div>
  )
}

export default EditUnitInstanceSidePageContent
